import { render, staticRenderFns } from "./layOutHome.vue?vue&type=template&id=755a80dd&scoped=true&lang=html&"
import script from "./layOutHome.vue?vue&type=script&lang=js&"
export * from "./layOutHome.vue?vue&type=script&lang=js&"
import style0 from "./layOutHome.vue?vue&type=style&index=0&id=755a80dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755a80dd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('755a80dd')) {
      api.createRecord('755a80dd', component.options)
    } else {
      api.reload('755a80dd', component.options)
    }
    module.hot.accept("./layOutHome.vue?vue&type=template&id=755a80dd&scoped=true&lang=html&", function () {
      api.rerender('755a80dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "layouts/layOutHome.vue"
export default component.exports